import { Component } from '@angular/core'

@Component({
   selector: 'app-bookmarks',
   standalone: true,
   imports: [],
   templateUrl: './bookmarks.component.html',
   styles: ''
})
export class BookmarksComponent {

}
